export type TemplatePart = { type: 'text'; value: string } | { type: 'param'; key: string };

/**
 * Splits a translation string containing `{paramName}` placeholders into an
 * ordered list of text and param parts, so a component can render each
 * placeholder as markup (e.g. a link) instead of plain text.
 */
export function parseTemplate(template: string): TemplatePart[] {
  const parts: TemplatePart[] = [];
  const paramPattern = /\{(\w+)\}/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = paramPattern.exec(template))) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', value: template.slice(lastIndex, match.index) });
    }
    parts.push({ type: 'param', key: match[1].toLowerCase() });
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < template.length) {
    parts.push({ type: 'text', value: template.slice(lastIndex) });
  }

  return parts;
}
